<template>
  <div>
    <UiPageHeader>
      <template #default>{{ $t('categories') }}</template>
      <template #page-specific-content>
        <div class="tw-flex tw-gap-6 tw-justify-between tw-flex-1 tw-items-center">
          <tooltip-select tip="_categories"></tooltip-select>
          <div class="tw-flex tw-items-center tw-gap-4">
            <download-button
              :data="categories"
              label="Download Categories"
              fileNamePrefix="categories"
              :headers="exportHeaders"
              :headerMapping="exportHeaderMapping"
              @download-complete="onDownloadComplete"
              iconClass="tw-text-primary-300 hover:tw-text-primary-400"
            />
            <create-category
              :connections="connections"
              :is-loading="isLoading"
              @refresh="refreshCategories"
              v-if="checkScope(scopeLiterals.CategoriesCreate)"
            />
            <v-menu offset-y>
              <v-btn slot="activator" color="secondary" dark :small="true" colo class="secondary">
                {{ $tc('_action', 2) }}
                <i class="material-icons"> arrow_drop_down </i>
              </v-btn>
              <v-list>
                <v-list-tile v-if="checkScope(scopeLiterals.CategoriesUpdate)">
                  <v-list-tile @click="disableAll()">
                    <v-list-tile-title>Disable All</v-list-tile-title>
                  </v-list-tile>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </div>
      </template>
    </UiPageHeader>
    <div class="tw-py-4 tw-px-6">
      <categories ref="categoriesRef" />
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag';

import { ConnectionCategory } from '@/api-svc-types';
import UiPageHeader from '@/components/ui/UiPageHeader.vue';

import DownloadButton from '../../components/common/DownloadButton.vue';
import Categories from '../../components/company/Categories.vue';
import CreateCategory from '../../components/company/CreateCategory.vue';

export default {
  props: [],
  components: {
    Categories,
    CreateCategory,
    UiPageHeader,
    DownloadButton,
  },
  apollo: {
    connections: {
      query: gql`
        query GetConnections($orgId: ID!) {
          connections(orgId: $orgId, overrideCache: true) {
            id
            provider
            isDisabled
            isDeleted
            category
            name
          }
        }
      `,
      variables() {
        return {
          orgId: this.$store.state.currentOrg.id,
        };
      },
      loadingKey: 'isLoading',
      update(data) {
        return (
          data.connections?.filter((x) => !x.isDeleted && x.category === ConnectionCategory.AccountingConnection) || []
        );
      },
    },
  },
  data() {
    return {
      connections: [],
      isLoading: 0,
      // Export headers for CSV download
      exportHeaders: ['id', 'name', 'description', 'type', 'enabled', 'remoteId', 'accountingConnectionId', 'source'],
      // Header mapping for CSV download
      exportHeaderMapping: {
        id: 'ID',
        name: 'Name',
        description: 'Description',
        type: 'Type',
        enabled: 'Enabled',
        remoteId: 'Remote ID',
        accountingConnectionId: 'Accounting Connection ID',
        source: 'Source',
      },
    };
  },
  computed: {
    categories() {
      return this.$store.getters['categories/CATEGORIES'] || [];
    },
  },
  methods: {
    onDownloadComplete() {
      console.log('Categories download completed');
      // You can add additional logic here if needed, such as showing a notification
    },
    refreshCategories() {
      this.$refs.categoriesRef.refresh();
    },
    async disableAll() {
      const vars = {
        orgId: this.$store.state.currentOrg.id,
      };

      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation ($orgId: ID!) {
              disableCategories(orgId: $orgId) {
                success
              }
            }
          `,
          // Parameters
          variables: vars,
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
